import { render } from "./Page20.vue?vue&type=template&id=2d0f0325"
import script from "./Page20.vue?vue&type=script&lang=js"
export * from "./Page20.vue?vue&type=script&lang=js"

import "./Page20.vue?vue&type=style&index=0&id=2d0f0325&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__